module.exports = __webpack_public_path__ + "static/media/logo_ingwebDark.d5aa1f5b.svg";